/* eslint-disable no-unused-vars */
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import AddIcon from "@mui/icons-material/Add";
import PCheck from "../../components/pos/PCheck";
import PConfirm from "../../components/pos/PConfirm";
import PDialog from "../../components/pos/PDialog";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { useHotkeys } from "react-hotkeys-hook";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { SyncUtils } from "../../utils/SyncUtils";
import CategoryCrud from "../category/CategoryCrud";
import VendorCrud from "../vendor/VendorCrud";
import KitItems from "./KitItems";
import ProductImages from "./ProductImages";
import ProductPricing from "./ProductPricing";
import ProductHistory from "./ProductHistory";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { SaleUtils } from "../../utils/SaleUtils";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";
import { RollerSkatingOutlined } from "@mui/icons-material";
import ProductStockBatchView from "./product-more-actions/ProductStockBatchView";

const theme = createTheme({
  components: {
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: 0,
          "@media (min-width: 600px)": {
            minHeight: 0,
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        marginNormal: {
          marginTop: 0,
          marginBottom: 0,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },
        /*root: {
          '&[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
          },
        },*/
        /*inputRoot: {
          '&[class*="MuiOutlinedInput-root"] ': {
            padding: 0,
            "& $input": {
              padding: "5px 4px",
            },
            '&[class*="MuiOutlinedInput-input"] ': {

            },
            "& $input:first-child": {
              paddingLeft: 2,
            },
          },
        },
        input: {
          padding: 0,
        },
        root: {
          padding: 0,
        },*/
      },
    },
    MuiChip: { styleOverrides: { root: { height: 20 } } },
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          padding: 2,
          color: "#555555",
        },
      },
    },
    MUIDataTableBodyRow: {
      styleOverrides: {
        root: {
          "&:nth-child(odd)": {
            backgroundColor: "#fafafa",
          },
        },
      },
    },

    PrivateSwitchBase: {
      styleOverrides: {
        root: {
          padding: 0,
          marginLeft: 12,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
        input: {
          padding: 5,
          marginLeft: 2,
          fontSize: 15,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 15,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          lineHeight: "0 rem",
        },
        root: {
          padding: 5,
        },
        paddingCheckbox: {
          width: 0,
        },
      },
      MuiIconButton: {
        root: {
          padding: 2,
        },
      },
    },
  },
});
function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function ProductCrud(props) {
  const { t } = useTranslation();
  const translate = t;

  const [mode, setMode] = useState("create");
  const [windowTitle, setWindowTitile] = useState(translate("New Product"));
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [code, setCode] = useState("AUTO");
  const [codeError, setCodeError] = useState("");
  const [deptId, setDeptid] = useState("");
  const [deptIdError, setDeptidError] = useState("");
  const [deptIdOptions, setDeptidOptions] = useState([]);
  const [subDeptId, setSubdeptid] = useState("");
  const [subDeptIdError, setSubdeptidError] = useState("");
  const [subDeptIdOptions, setSubdeptidOptions] = useState([]);
  const [catId, setCatid] = useState("");
  const [catIdError, setCatidError] = useState("");
  const [catIdOptions, setCatidOptions] = useState([]);
  const [subCatId, setSubcatid] = useState("");
  const [subCatIdError, setSubcatidError] = useState("");
  const [subCatIdOptions, setSubcatidOptions] = useState([]);
  const [vendorId, setVendorid] = useState("");
  const [vendorIdError, setVendoridError] = useState("");
  const [vendorIdOptions, setVendoridOptions] = useState([]);

  const [kotPrinter, setKotPrinter] = useState("");

  const [taxId, setTaxid] = useState("");
  const [taxIdError, setTaxidError] = useState("");
  const [taxIdOptions, setTaxidOptions] = useState([]);
  const [shortName, setShortname] = useState("");
  const [shortNameError, setShortnameError] = useState("");
  const [localName, setLocalname] = useState("");
  const [localNameError, setLocalnameError] = useState("");
  const [deliItemUom, setDeliitemuom] = useState("");
  const [deliItemUomError, setDeliitemuomError] = useState("");
  const [unitSymbol, setUnitsymbol] = useState("");
  const [unitSymbolError, setUnitsymbolError] = useState("");
  const [currentStock, setCurrentstock] = useState("");
  const [currentStockError, setCurrentstockError] = useState("");
  const [isOpenPrice, setIsopenprice] = useState(false);
  const [isOpenQty, setIsOpenQty] = useState(false);
  const [isOpenQtyError, setIdOpenQtyError] = useState(false);
  const [isOpenPriceError, setIsopenpriceError] = useState(false);
  const [isDiscounted, setIsdiscounted] = useState(false);
  const [includeTaxInPrice, setIncludetaxinprice] = useState(false);
  const [includeDiscInPrice, setIncludediscinprice] = useState(false);
  const [fastItem, setFastitem] = useState(false);
  const [summaryViewOpen, setSummaryViewOpen] = useState(false);
  const [foodCategoryOptions, setFoodCategoryOptions] = useState([
    {
      name: "VEG",
      id: "VEG",
    },
    {
      name: "NON-VEG",
      id: "NON-VEG",
    },
    {
      name: "VEGAN",
      id: "VEGAN",
    },
  ]);
  const [foodCategory, setFoodCategory] = useState(null);
  const [foodCategoryError, setFoodCategoryError] = useState("");

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  const [kitItemsList, setKitItemsList] = useState([]);
  const [isStockItem, setIsStockItem] = useState(false);
  const [isExpandOnSale, setIsExpandOnSale] = useState(false);
  const [pricingData, setPricingData] = useState(getDefaultPricing());
  const [showProductPricing, setShowProductPricing] = useState(true);

  const [stockCalculation, setStockCalculation] = useState([]);

  const [tabValue, setTabValue] = React.useState(0);
  const [outerTabValue, setOuterTabValue] = React.useState(0);

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [filesList, setFilesList] = useState([]);
  const [productInfoFields, setProductInfoFields] = useState([]);
  const [isKitItem, setIsKitItem] = useState(false);
  const [borderLess, setBorderLess] = useState(false);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [isForPos, setIsForPos] = useState(false);

  const handleOuterTabChange = (event, newValue) => {
    if (newValue == 0) {
      setBorderLess(false);
    } else {
      setBorderLess(true);
    }
    setOuterTabValue(newValue);

    console.log("setOuterTabValue", newValue);
  };
  var biRef = {};

  const uomMap = {
    Q: translate("Quantity"),
    P: translate("Price"),
    W: translate("Weight"),
  };

  useHotkeys("ctrl+k", (event, handler) => {
    event.preventDefault();
    console.log("Ctrl + k pressed");
  });

  useEffect(() => {
    populateDept();
    populateVendor();

    populateTax();
    loadProductInfoFields();
  }, []);

  useEffect(() => {
    if (taxIdOptions?.length == 1) {
      setTaxid(taxIdOptions[0]);
    }
  }, [taxIdOptions]);

  useEffect(() => {
    if (props.origObject) {
      setMode("edit");
      populateData(props.origObject);
      setWindowTitile(props.origObject.name);
    }
  }, [props.origObject]);

  async function loadProductInfoFields() {
    setProductInfoFields(props.productInfoFields);
  }

  function calulateStock() {
    let data = [];
    for (let d of pricingData) {
      if (currentStock >= d[1].v) {
        if (d[1].v != 0 && d[0].v.name != "") {
          let i = [
            {
              name: d[0].v.name,
              value: parseFloat(currentStock / d[1].v).toFixed(3),
            },
          ];
          data.push(i);
        }
      } else {
        props.showMessage("error", translate("Out of stock"));
        if (d[1].v != 0 && d[0].v.name != "") {
          let i = [
            {
              name: d[0].v.name,
              value: parseFloat(0.0).toFixed(3),
            },
          ];
          data.push(i);
        }
      }
    }
    setStockCalculation(data);
  }

  console.log("364>>stockCalculation", stockCalculation);

  async function getPromotionById(promotionId) {
    let dbData = await db.promotion.toArray();
    for (let promotion of dbData) {
      if (promotion.id === promotionId)
        return {
          label: promotion.policyName,
          value: promotion,
        };
    }
  }

  const handleClose = () => {
    setSummaryViewOpen(!summaryViewOpen);
  };

  useEffect(() => {
    if (!showProductPricing) setShowProductPricing(true);
  }, [showProductPricing]);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  useEffect(() => {
    if (liveValidation && code === "")
      setCodeError(translate("Code is Required"));
    else setCodeError("");
  }, [code]);
  useEffect(() => {
    if (liveValidation && deptId === "")
      setDeptidError(translate("Department is Required"));
    else setDeptidError("");
  }, [deptId]);
  useEffect(() => {
    if (liveValidation && vendorId === "")
      setVendoridError(translate("Vendor is Required"));
    else setVendoridError("");
  }, [vendorId]);
  useEffect(() => {
    if (liveValidation && taxId === "") setTaxidError("Tax is Required");
    else setTaxidError("");
  }, [taxId]);

  useEffect(() => {
    if (liveValidation && deliItemUom === "" && props.productType != "R")
      setDeliitemuomError(translate("Deliitem UOM is Required"));
    else setDeliitemuomError("");
  }, [deliItemUom]);
  useEffect(() => {
    if (liveValidation && unitSymbol === "" && props.productType != "R")
      setUnitsymbolError(translate("Unit symbol is Required"));
    else setUnitsymbolError("");
  }, [unitSymbol]);
  // useEffect(() => {
  //   if (liveValidation && currentStock === "")
  //     setCurrentstockError(translate("Currentstock is Required"));
  //   else setCurrentstockError("");
  // }, [currentStock]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showProductCrudWindow(productId) {
    setOuterTabValue(0);

    setPricingData([]);
    setKitItemsList([]);
    setTabValue(0);
    if (productId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setCode("AUTO");
      createDefaultPricing();
    } else {
      setMode(
        props.context.privileges.delete_product ||
          props.context.privileges.edit_product
          ? "edit"
          : "view"
      );
      // setMode("edit");
      populateProduct(productId);
    }
  }

  async function populateProduct(id) {
    {
      try {
        let { data } = await API.get("/api/v1/product/" + id);
        props.setOrigObject(data);
        //setOpenWindow(true);
      } catch (err) {
        console.log(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Product data from server")
        );
      }
    }
  }

  function getDefaultPricing() {
    var d = [
      [
        {
          v: {
            name: props.unitTypeOptions[0].name,
            code: props.unitTypeOptions[0].code,
          },
          e: "",
        },
        { v: "1", e: "" },
        { v: "0", e: "" },
        { v: "0", e: "" },
        { v: "0", e: "" },
        { v: "0", e: "" },
        { v: [], e: "" },
        { o: props.promotionOptions, v: [], e: "" },
        { marginOnRsp: 0, info: { incTax: false, incDisc: false } },
        null,
        includeTaxInPrice,
        includeDiscInPrice,
        {},
        [],
        props.pricingLevels,
        [] /*ingredientsList*/,
      ],
    ];
    return d;
  }

  function createDefaultPricing() {
    //biRefPrice.child.parentEvent("refreshCard", d[0]);
    //biRefPrice.child.parentEvent("configureColumns", d.length);
    setPricingData(getDefaultPricing());
  }

  async function populateData(bean) {
    console.log("501>>bean", bean);
    setName(bean.name);
    setCode(bean.code);
    setDeptid(
      bean.deptId
        ? {
            id: bean.deptId,
            name: bean.deptName,
            code: bean.deptBean.catCode,
            deliItem: bean.deptBean.deliItem,
          }
        : null
    );
    setSubdeptid(
      bean.subDeptId ? { id: bean.subDeptId, name: bean.subDeptName } : null
    );
    setCatid(bean.catId ? { id: bean.catId, name: bean.catName } : null);
    setSubcatid(
      bean.subCatId ? { id: bean.subCatId, name: bean.subCatName } : null
    );
    setVendorid(
      bean.vendorId ? { id: bean.vendorId, name: bean.vendorName } : null
    );
    if (props.context.appType === "R_POS") {
      console.log(props.kotPrinterOptions);
      setKotPrinter(
        bean.kotPrinterId
          ? SaleUtils.getOption(props.kotPrinterOptions, bean.kotPrinterId)
          : null
      );
    }
    setVendorid(
      bean.vendorId ? { id: bean.vendorId, name: bean.vendorName } : null
    );
    setTaxid(
      bean.taxId
        ? {
            id: bean.taxId,
            name: bean.taxBean.name,
            rate: bean.taxBean.rate,
          }
        : null
    );
    setShortname(bean.shortName);
    setLocalname(bean.localName);
    setDeliitemuom(
      bean.uom ? { value: bean.uom, name: uomMap[bean.uom] } : null
    );
    setUnitsymbol(bean.unitSymbol);
    setCurrentstock(bean.stockBean ? bean.stockBean.currentStock : "0.0");
    setIsopenprice(bean.isOpenPrice);
    setIsOpenQty(bean.isOpenQty);
    setIsdiscounted(bean.isDiscounted);
    setIncludetaxinprice(bean.includeTaxInPrice);
    setIncludediscinprice(bean.includeDiscountInPrice);
    setFastitem(bean.isFastItem);
    setIsStockItem(bean.isStockItem);
    setIsExpandOnSale(bean.isExpandKitDuringSale);
    setIsForPos(bean.isForPos ? bean.isForPos : false);

    setIsKitItem(bean.isKit);

    if (bean.kitItems != null) populateKitItems(bean.kitItems, bean);
    if (bean.productFiles) populateProductFiles(bean.productFiles);
    await populatePricingData(bean);
    let customeFields = [];

    setProductInfoFields(props.productInfoFields);
    if (props.productInfoFields) customeFields = props.productInfoFields;

    /*Populate product info <fields></fields>*/
    for (let i = 0; i < customeFields.length; i++) {
      customeFields[i].value = bean[customeFields[i].key];
    }

    setProductInfoFields(customeFields);

    if (bean.foodCategoryId && bean.foodCategoryName) {
      setFoodCategory({ name: bean.foodCategoryName, id: bean.foodCategoryId });
    }

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  async function populateProductFiles(productFileList) {
    let tempFileList = [];
    productFileList.map((fileEntry) => {
      tempFileList.push({
        serialNumber: tempFileList.length + 1,
        fileId: fileEntry.fileId,
        fileCategorySelected: {
          name: fileEntry.fileCategoryName,
          id: fileEntry.fileCategoryId,
        },
        fileCategoryId: fileEntry.fileCategoryId,
        fileCategoryName: fileEntry.fileCategoryName,
        fileName: fileEntry.fileName,
        fileSize: fileEntry.fileSize,
        fileSizeText: fileEntry.fileSizeText,
        fileType: fileEntry.fileType,
        fileData: null,
      });
    });
    setFilesList(tempFileList);
  }

  async function loadPromotions() {
    let dbData = await db.promotion.toArray();
    let promotionOptions = [];
    for (let promotion of dbData) {
      promotionOptions.push({ label: promotion.policyName, value: promotion });
    }
    return promotionOptions;
  }

  async function populatePricingData(bean) {
    var data = [];
    for (let i = 0; i < bean.productPricingBeanList.length; i++) {
      let v = bean.productPricingBeanList[i];
      let barcodes = [];

      for (let j = 0; j < v.productBarcodeBeanList.length; j++) {
        barcodes.push(v.productBarcodeBeanList[j].barcode);
      }

      let promotionList = [];
      if (
        v.promotionBeanList != null &&
        v.promotionBeanList != undefined &&
        v.promotionBeanList != ""
      ) {
        for (let k = 0; k < v.promotionBeanList.length; k++) {
          promotionList.push(await getPromotionById(v.promotionBeanList[k].id));
        }
      }

      let d = [
        {
          v: {
            code: bean.productPricingBeanList[i].unitType,
            name: bean.productPricingBeanList[i].unitTypeName
              ? bean.productPricingBeanList[i].unitTypeName
              : bean.productPricingBeanList[i].unitType,
          },
          e: "",
        },
        { v: bean.productPricingBeanList[i].factor, e: "" },
        {
          v: bean.productPricingBeanList[i].cost,
          e: "",
        },
        { v: bean.productPricingBeanList[i].marginPer, e: "" },
        { v: bean.productPricingBeanList[i].margin, e: "" },
        { v: bean.productPricingBeanList[i].price, e: "" },
        { v: barcodes, e: "" },
        {
          o: await loadPromotions(),
          v: promotionList,
          v2: bean.productPricingBeanList[i].productLevelPromotion,
          e: "",
        },
        {
          marginOnRsp: 0,
          info: {
            incTax: bean.includeTaxInPrice,
            incDisc: bean.includeDiscountInPrice,
          },
        },
        null,
        includeTaxInPrice,
        includeDiscInPrice,
        {},
        bean.productPricingBeanList[i].pricingLevelBeanList != null
          ? bean.productPricingBeanList[i].pricingLevelBeanList
          : [],
        props.pricingLevels,
        bean.productPricingBeanList[i].ingredientsList
          ? bean.productPricingBeanList[i].ingredientsList
          : [],
      ];
      data.push(d);
    }
    setPricingData(data);
    setShowProductPricing(false);
  }

  function getName(code) {
    for (let d of props.unitTypeOptions) {
      if (d.code === code) {
        return d.name;
      }
    }
  }

  async function populateKitItems(kitItemsList, productBean) {
    let tempKitItemList = [];
    for (let i = 0; i < kitItemsList.length; i++) {
      let dbData = await db.product
        .where("id")
        .equals(kitItemsList[i].productId)
        .toArray();
      if (dbData[0] != null && dbData[0] != undefined) {
        let orderItem = [
          { v: i + 1 },
          { v: dbData[0].name },
          { v: kitItemsList[i].unitType },
          { v: dbData[0].code },
          { v: kitItemsList[i].Barcode },
          { v: kitItemsList[i].quantity },
          {
            info: {
              productBean: dbData[0],
            },
          },
          { id: kitItemsList[i].id },
        ];
        tempKitItemList.push(orderItem);
      }
    }
    setKitItemsList(tempKitItemList);
  }

  function resetFields() {
    setName("");
    setNameError("");
    setCode("");
    setCodeError("");
    setDeptid("");
    setDeptidError("");
    setSubdeptid("");
    setSubdeptidError("");
    setCatid("");
    setCatidError("");
    setSubcatid("");
    setSubcatidError("");
    setVendorid("");
    setVendoridError("");
    setFoodCategoryError("");
    setTaxid("");
    setTaxidError("");
    setShortname("");
    setShortnameError("");
    setLocalname("");
    setLocalnameError("");

    setDeliitemuom("");
    setDeliitemuomError("");
    setUnitsymbol("");
    setUnitsymbolError("");
    setCurrentstock("");
    setCurrentstockError("");
    setIsopenprice(false);
    setIsOpenQty(false);
    setIsdiscounted(false);
    setIncludetaxinprice(false);
    setIncludediscinprice(false);
    setFastitem("");
    setIsExpandOnSale(false);
    setIsStockItem(true);
    setFilesList([]);
    setIsKitItem(false);
    setKotPrinter(null);
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    props.setShowCrud(false);
    //setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete product :") +
        props.origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        showProgress(true, "Deleting...");
        let result = await API.delete("/api/v1/product/" + props.origObject.id);
        props.showMessage(
          "warning",
          translate("Product") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        props.setShowCrud(false);
        //setOpenWindow(false);
        showProgress(false, "Deleting...");
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Product"));
        showProgress(false, "Deleting...");
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  function onNewClicked() {
    showProductCrudWindow(null);
    setMode("create");
  }

  async function onSave() {
    if (validate() && validateCodes()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/product", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        //setOpenWindow(false);
        //props.setShowCrud(false);
        props.setOrigObject(result.data);
        setMode("edit");
        showProductCrudWindow(result.data.id);
        showProgress(false, "Saving");
        if (props.onProductSaved) {
          props.onProductSaved(result.data);
        }
      } catch (err) {
        console.log(err);
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Product"));
        }
        showProgress(false, "Saving");
      }
    } else {
      props.showMessage("warning", translate("Validation Failed"));
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      if (obj.field === "code") {
        setCodeError(obj.message);
      }
      if (obj.field === "deptId") {
        setDeptidError(obj.message);
      }
      if (obj.field === "subDeptId") {
        setSubdeptidError(obj.message);
      }
      if (obj.field === "catId") {
        setCatidError(obj.message);
      }
      if (obj.field === "subCatId") {
        setSubcatidError(obj.message);
      }
      if (obj.field === "vendorId") {
        setVendoridError(obj.message);
      }
      if (obj.field === "taxId") {
        setTaxidError(obj.message);
      }
      if (obj.field === "shortName") {
        setShortnameError(obj.message);
      }
      if (obj.field === "localName") {
        setLocalnameError(obj.message);
      }
      if (obj.field === "deliItemUom") {
        setDeliitemuomError(obj.message);
      }
      if (obj.field === "unitSymbol") {
        setUnitsymbolError(obj.message);
      }
      // if (obj.field === "currentStock") {
      //   setCurrentstockError(obj.message);
      // }
      if (obj.field === "barcode") {
        renderServerValidation(obj);
      }

      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function renderServerValidation(errMsg) {
    let position = parseInt(errMsg.infoFields.position);
    let d = [...pricingData];
    d[position][6].e = errMsg.message;
    setPricingData(d);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["name"] = name;
    saveObject["code"] = code;
    saveObject["deptId"] = deptId ? deptId.id : null;
    saveObject["subDeptId"] = subDeptId ? subDeptId.id : null;
    saveObject["catId"] = catId ? catId.id : null;
    saveObject["subCatId"] = subCatId ? subCatId.id : null;
    saveObject["vendorId"] = vendorId ? vendorId.id : null;
    saveObject["taxId"] = taxId ? taxId.id : null;
    saveObject["shortName"] = shortName;
    saveObject["localName"] = localName;
    saveObject["uom"] = deliItemUom ? deliItemUom.value : null;
    saveObject["unitSymbol"] = unitSymbol;
    saveObject["currentStock"] = currentStock ? currentStock : "0";
    saveObject["isOpenPrice"] = isOpenPrice;
    saveObject["isOpenQty"] = isOpenQty;
    saveObject["isDiscounted"] = isDiscounted;
    saveObject["includeTaxInPrice"] = includeTaxInPrice;
    saveObject["includeDiscountInPrice"] = includeDiscInPrice;
    saveObject["isFastItem"] = fastItem;
    saveObject["productType"] = "I";
    if (props.context.appType === "M_POS") {
      saveObject["isForPos"] = isForPos;
    }
    if (props.context.appType === "R_POS") {
      if (props.productType == "R") {
        saveObject["isForPos"] = true;
        saveObject["productType"] = "R";
      } else {
        saveObject["isForPos"] = isForPos;
        if (isForPos) saveObject["productType"] = "R";
      }

      if (foodCategory) {
        saveObject["foodCategoryId"] = foodCategory.id;
        saveObject["foodCategoryName"] = foodCategory.name;
      }
    } else if (props.context.appType === "M_POS") {
      if (props.productType == "P") {
        saveObject["isForPos"] = true;
        saveObject["productType"] = "P";
      }
    } else if (props.productType == "S") {
      saveObject["isForPos"] = true;
      saveObject["productType"] = "S";
    } else {
      saveObject["isForPos"] = true;
    }
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/

    saveObject["productPricingBeanList"] = getProductPricingBeanList();

    saveObject["productFiles"] = filesList;

    saveObject["kitItems"] = prepareKitItemPayload();
    saveObject["isKit"] = isKitItem;
    saveObject["isStockItem"] = isStockItem;
    saveObject["isExpandKitDuringSale"] = isExpandOnSale;

    saveObject["facePrice"] = facePrice();
    if (kotPrinter) saveObject["kotPrinterId"] = kotPrinter.id;

    /*Product info fields*/
    productInfoFields.map((item) => {
      saveObject[item.key] = item.value;
    });

    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = props.origObject.id;
      saveObject["intVersion"] = props.origObject.intVersion;
    }

    return saveObject;
  }

  function facePrice() {
    return pricingData[0][8].priceExPromotionExTax;
  }

  function getProductPricingBeanList() {
    let payLoad = [];
    for (let i = 0; i < pricingData.length; i++) {
      let barcodes = [];
      for (let j = 0; j < pricingData[i][6].v.length; j++) {
        barcodes.push({
          position: j + 1,
          barcode: pricingData[i][6].v[j],
        });
      }

      /*Promotion IDs*/
      let promotionsIdList = [];
      for (let k = 0; k < pricingData[i][7].v.length; k++) {
        promotionsIdList.push(pricingData[i][7].v[k].value.id);
      }
      let productLevelPromotion = {};
      if (pricingData[i][7].v2) {
        productLevelPromotion = pricingData[i][7].v2;
      }

      payLoad.push({
        unitType: pricingData[i][0].v.code,
        unitTypeName: pricingData[i][0].v.name,
        factor: props.productType == "R" ? 1 : pricingData[i][1].v,
        cost: pricingData[i][2].v,
        margin: pricingData[i][3].v,
        marginPer: pricingData[i][4].v,
        position: i + 1,
        price: pricingData[i][5].v,
        productBarcodeBeanList: barcodes,
        promotionIds: promotionsIdList,
        pricingLevelBeanList: pricingData[i][13],
        ingredientsList: pricingData[i][15],
        productLevelPromotion: productLevelPromotion,
      });
    }
    return payLoad;
  }

  function prepareKitItemPayload() {
    let payload = [];

    kitItemsList.map((item) => {
      payload.push({
        id: item[7].id,
        productId: item[6].info.productBean.id,
        productName: item[1].v,
        unitType: item[2].v,
        quantity: item[5].v,
        Barcode: item[4].v,
      });
    });
    return payload;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    if (!code || code === "") {
      setCodeError(translate("Code is Required"));
      flag = false;
    }
    if (!deptId || deptId === "") {
      setDeptidError(translate("Departmant is Required"));
      flag = false;
    }
    if (!vendorId || vendorId === "") {
      setVendoridError(translate("Vendor is Required"));
      flag = false;
    }
    if (!taxId || taxId === "") {
      setTaxidError(translate("Tax is Required"));
      flag = false;
    }

    if (!deliItemUom || deliItemUom === "") {
      //TODO only iF dept is Deli
      //setDeliitemuomError("Deliitemuom is Required");
      //flag = false;
    }
    if (!unitSymbol || unitSymbol === "") {
      //setUnitsymbolError("Unitsymbol is Required");
      //flag = false;
    }

    if (props.context.appType === "R_POS" && props.productType == "R") {
      if (!foodCategory) {
        setFoodCategoryError(translate("Food category is required"));
        flag = false;
      }
    }

    if (!validatePricing()) {
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/

    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function validatePricing() {
    let flag = true;
    let d = [...pricingData];
    let uTypes = [];
    for (let i = 0; i < d.length; i++) {
      if (!d[i][0].v.name || d[i][0].v.name == "") {
        d[i][0].e = translate("Unit Type Required");
        flag = false;
      }
      if (uTypes.includes(d[i][0].v.name)) {
        d[i][0].e = translate("Duplicate Unit Type");
        flag = false;
      }

      if (!d[i][6].v || d[i][6].v.length == 0) {
        d[i][6].e = translate("Barcode Required");

        flag = false;
      }
      if (d[i][6].v && d[i][6].v.length > 0) {
        for (let barcode of d[i][6].v) {
          if (!barcode || barcode === "") {
            d[i][6].e = translate("Barcode Required");
            flag = false;
          }
        }
      }
      if (!d[i][6].v || d[i][6].v.length > 0) {
        if (hasDuplicates(d[i][6].v)) {
          d[i][6].e = translate("Duplicate barcode");
          flag = false;
        }
        for (let bCode of d[i][6].v) {
          for (let j = 0; j < d.length; j++) {
            if (j != i) {
              if (!d[j][6].v || d[j][6].v.length > 0) {
                for (let b of d[j][6].v) {
                  if (bCode === b) {
                    d[i][6].e = translate("Duplicate barcode");
                    flag = false;
                  }
                }
              }
            }
          }
        }
      }

      if (props.productType != "R") {
        if (!d[i][1].v || d[i][1].v.length == 0 || parseFloat(d[i][1].v) <= 0) {
          d[i][1].e = translate("Factor should be greater than Zero");
          flag = false;
        }
      }
      uTypes.push(d[i][0].v.name);
    }

    setPricingData(d);
    return flag;
  }

  function hasDuplicates(arr) {
    var counts = [];

    for (var i = 0; i <= arr.length; i++) {
      if (counts[arr[i]] === undefined) {
        counts[arr[i]] = 1;
      } else {
        return true;
      }
    }
    return false;
  }

  function validateCodes() {
    let flag = true;
    let pricingList = getProductPricingBeanList();
    console.log(pricingList);
    for (let price of pricingList) {
      for (let bar of price.productBarcodeBeanList) {
        if (code.toUpperCase() === bar.barcode.toUpperCase()) {
          setCodeError(translate("Item code can not be same as barcode"));
          flag = false;
        }
      }
    }
    if (!validateBarcodes(code)) {
      flag = false;
    }
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  function validateBarcodes(itemCode) {
    let flag = true;
    let d = [...pricingData];
    for (let i = 0; i < d.length; i++) {
      if (!d[i][6].v || d[i][6].v.length > 0) {
        for (let barcode of d[i][6].v) {
          if (itemCode.toUpperCase() === barcode.toUpperCase()) {
            d[i][6].e = translate("Barcode Can not be Same as Item Code");
            flag = false;
          }
        }
        if (flag) {
          d[i][6].e = "";
        }
      }
    }
    setPricingData(d);
    return flag;
  }

  async function populateVendor() {
    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name });
        }
      }
      console.log("Vendors");
      console.log(dat);
      setVendoridOptions(dat);
    });
  }

  async function populateDept() {
    setSubdeptidOptions([]);
    setSubcatidOptions([]);
    setCatidOptions([]);

    db.category
      .where("level")
      .equals(0)
      .toArray(function (data) {
        let dat = [];
        for (let i = 0; i < data.length; i++) {
          if (!data[i].parent_id) {
            dat.push({
              id: data[i].id,
              name: data[i].name,
              code: data[i].catCode,
              deliItem: data[i].deliItem,
            });
          }
        }
        setDeptidOptions(dat);
      });
  }

  async function populateSubDept(option) {
    setCatidOptions([]);
    setSubcatidOptions([]);
    db.category.toArray(function (data) {
      let dat = [];
      if (option) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
        setSubdeptidOptions(dat);
      }
    });
  }

  async function populateCategory(option) {
    setSubcatidOptions([]);
    db.category.toArray(function (data) {
      let dat = [];
      if (option)
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
      setCatidOptions(dat);
    });
  }

  async function populateSubCategory(option) {
    db.category.toArray(function (data) {
      let dat = [];
      if (option)
        for (let i = 0; i < data.length; i++) {
          if (data[i].parentId === option.id) {
            dat.push({ id: data[i].id, name: data[i].name });
          }
        }
      setSubcatidOptions(dat);
    });
  }

  async function populateTax() {
    db.tax.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].parent_id) {
          dat.push({ id: data[i].id, name: data[i].name, rate: data[i].rate });
        }
      }
      setTaxidOptions(dat);
    });
  }

  var biRefPrice = {};

  function selectVendor(vendorBean) {
    let vendorOptions = vendorIdOptions;
    vendorOptions.push({ id: vendorBean.id, name: vendorBean.name });
    setVendoridOptions(vendorOptions);
    //setVendorid({ id: vendorBean.id, name: vendorBean.name });
  }

  function selectCategory(deptBean) {
    let dat = deptIdOptions;
    dat.push({
      id: deptBean.id,
      name: deptBean.name,
      code: deptBean.catCode,
      deliItem: deptBean.deliItem,
    });
    setDeptidOptions(dat);
  }

  async function txtCodeKeyPressed(e) {
    if (e.key === "Enter") {
      console.log("txtCodeKeyPressed:" + code);
      if (code && code.length > 0) {
        let dbData = await db.product
          .where("barcodeList")
          .equals(code)
          .or("code")
          .equals(code)
          .toArray();
        if (dbData.length == 0) {
          props.showMessage("warning", translate("Product Not Found"));
        } else {
          let productBean = dbData[0];
          showProductCrudWindow(productBean.id);
        }
      }
    }
  }

  const content = (
    <ThemeProvider theme={theme}>
      <div>
        <Tabs value={outerTabValue} onChange={handleOuterTabChange}>
          <Tab label={translate("Product")} />
          <Tab label={translate("Stock Batch")} />
          <Tab label={translate("History")} />
          <Tab label={translate("Product Images")} />
          <Tab label={translate("More Info")} />
          {isKitItem && (
            <Tab
              label={
                props.productType == "R"
                  ? translate("Combo Items")
                  : translate("Kit Items")
              }
            />
          )}
        </Tabs>

        <TabPanel value={outerTabValue} index={0} style={{ padding: 0 }}>
          <Grid
            container
            sx={{ paddingLeft: "5px", paddingRight: "5px" }}
            style={{ height: 520 }}
          >
            <Grid item xs={12} sm={4}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>
                      <Typography variant="body1">
                        {translate("Code")}
                      </Typography>
                    </td>
                    <td>
                      <PText
                        value={code}
                        error={codeError}
                        onKeyDown={txtCodeKeyPressed}
                        disabled={props.context.store.shopType === "BRANCH"}
                        onChange={(e) => setCode(e.target.value)}
                      ></PText>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="body1">
                        {translate("Name")}
                      </Typography>
                    </td>
                    <td>
                      <PText
                        value={name}
                        autoFocus
                        error={nameError}
                        disabled={props.context.store.shopType === "BRANCH"}
                        onChange={(e) => {
                          setName(e.target.value);
                          setShortname(e.target.value);
                        }}
                      ></PText>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="body1">
                        {translate("Short Name")}
                      </Typography>
                    </td>
                    <td>
                      <PText
                        value={shortName}
                        error={shortNameError}
                        disabled={props.context.store.shopType === "BRANCH"}
                        onChange={(e) => setShortname(e.target.value)}
                      ></PText>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="body1">
                        {translate("Local Name")}
                      </Typography>
                    </td>
                    <td>
                      <PText
                        value={localName}
                        error={localNameError}
                        disabled={props.context.store.shopType === "BRANCH"}
                        onChange={(e) => setLocalname(e.target.value)}
                      ></PText>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="body1">
                        {translate("Vendor")}
                      </Typography>
                    </td>
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td width="97%">
                              <PSelect
                                options={vendorIdOptions}
                                value={vendorId}
                                placeholder={translate("Select...")}
                                disabled={
                                  props.context.store.shopType === "BRANCH"
                                }
                                errorMessage={vendorIdError}
                                onChange={(event, newValue) => {
                                  setVendorid(newValue);
                                }}
                              ></PSelect>
                            </td>

                            <td width="3%" style={{ paddingLeft: "5px" }}>
                              {props.context.store.shopType != "BRANCH" && (
                                <IconButton
                                  aria-label="close"
                                  onClick={() => {
                                    biRef.child.showVendorCrudWindow(null);
                                  }}
                                >
                                  <AddIcon />
                                </IconButton>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  {props.context.appType === "R_POS" &&
                    props.productType != "R" && (
                      <tr>
                        <td>
                          <Typography variant="body1">
                            {translate("KOT Printer")}
                          </Typography>
                        </td>
                        <td>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td>
                                  <PSelect
                                    options={props.kotPrinterOptions}
                                    value={kotPrinter}
                                    placeholder={translate("Select...")}
                                    disabled={
                                      props.context.store.shopType === "BRANCH"
                                    }
                                    onChange={(event, newValue) => {
                                      setKotPrinter(newValue);
                                    }}
                                  ></PSelect>
                                </td>
                                {/* <td width="3%" style={{ paddingLeft: "5px" }}>
                                <IconButton
                                  aria-label="close"
                                  onClick={() => {
                                    biRef.child.showVendorCrudWindow(null);
                                  }}
                                >
                                  <AddIcon />
                                </IconButton>
                              </td>*/}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} sm={4}>
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="130px">
                      <Typography variant="body1">
                        {translate("Department")}
                      </Typography>
                    </td>
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td>
                              <PSelect
                                options={deptIdOptions}
                                value={deptId}
                                errorMessage={deptIdError}
                                placeholder={translate("Select...")}
                                disabled={
                                  props.context.store.shopType === "BRANCH"
                                }
                                onChange={(event, newValue) => {
                                  setDeptid(newValue);
                                  setShowProductPricing(false);
                                  populateSubDept(newValue);
                                }}
                              ></PSelect>
                            </td>
                            <td width="1px">
                              {props.context.store.shopType != "BRANCH" && (
                                <IconButton
                                  aria-label="close"
                                  onClick={() => {
                                    biRef.deptChild.showCategoryCrudWindow(
                                      null,
                                      null,
                                      "create"
                                    );
                                  }}
                                >
                                  <AddIcon />
                                </IconButton>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  {props.productType != "R" && (
                    <tr>
                      <td>
                        <Typography variant="body1">
                          {translate("Sub Department")}
                        </Typography>
                      </td>
                      <td>
                        <PSelect
                          options={subDeptIdOptions}
                          value={subDeptId}
                          errorMessage={subDeptIdError}
                          placeholder={translate("Select...")}
                          disabled={props.context.store.shopType === "BRANCH"}
                          onChange={(event, newValue) => {
                            setSubdeptid(newValue);
                            populateCategory(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  )}
                  {props.productType != "R" && (
                    <tr>
                      <td>
                        <Typography variant="body1">
                          {translate("Category")}
                        </Typography>
                      </td>
                      <td>
                        <PSelect
                          options={catIdOptions}
                          value={catId}
                          errorMessage={catIdError}
                          placeholder={translate("Select...")}
                          disabled={props.context.store.shopType === "BRANCH"}
                          onChange={(event, newValue) => {
                            setCatid(newValue);
                            populateSubCategory(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  )}
                  {props.productType != "R" && (
                    <tr>
                      <td>
                        <Typography variant="body1">
                          {translate("Sub Category")}
                        </Typography>
                      </td>
                      <td>
                        <PSelect
                          options={subCatIdOptions}
                          value={subCatId}
                          errorMessage={subCatIdError}
                          placeholder={translate("Select...")}
                          disabled={props.context.store.shopType === "BRANCH"}
                          onChange={(event, newValue) => {
                            setSubcatid(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Typography variant="body1">
                        {translate("Tax")}
                      </Typography>
                    </td>
                    <td>
                      <PSelect
                        options={taxIdOptions}
                        value={taxId}
                        errorMessage={taxIdError}
                        placeholder={translate("Select...")}
                        disabled={props.context.store.shopType === "BRANCH"}
                        onChange={(event, newValue) => {
                          setTaxid(newValue);
                        }}
                      ></PSelect>
                    </td>
                  </tr>
                  {props.context.appType === "R_POS" && (
                    <tr>
                      <td>Food Category</td>
                      <td>
                        <PSelect
                          options={foodCategoryOptions}
                          value={foodCategory}
                          errorMessage={foodCategoryError}
                          placeholder={translate("Select...")}
                          disabled={props.context.store.shopType === "BRANCH"}
                          onChange={(event, newValue) => {
                            setFoodCategory(newValue);
                          }}
                        ></PSelect>
                      </td>
                    </tr>
                  )}

                  {props.context.appType === "R_POS" &&
                    props.productType == "R" && (
                      <tr>
                        <td>
                          <Typography variant="body1">
                            {translate("KOT Printer")}
                          </Typography>
                        </td>
                        <td>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td>
                                  <PSelect
                                    options={props.kotPrinterOptions}
                                    value={kotPrinter}
                                    placeholder={translate("Select...")}
                                    disabled={
                                      props.context.store.shopType === "BRANCH"
                                    }
                                    onChange={(event, newValue) => {
                                      setKotPrinter(newValue);
                                    }}
                                  ></PSelect>
                                </td>
                                {/* <td width="3%" style={{ paddingLeft: "5px" }}>
                                <IconButton
                                  aria-label="close"
                                  onClick={() => {
                                    biRef.child.showVendorCrudWindow(null);
                                  }}
                                >
                                  <AddIcon />
                                </IconButton>
                              </td>*/}
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12} sm={4}>
              <table width="100%">
                <tbody>
                  {props.productType != "R" && (
                    <tr>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td width="25%">{translate("Deli UOM")}</td>
                            <td>
                              <PSelect
                                style={{ width: "84%" }}
                                options={[
                                  { value: "P", name: translate("Price") },
                                  { value: "W", name: translate("Weight") },
                                  { value: "Q", name: translate("Quantity") },
                                ]}
                                value={deliItemUom}
                                errorMessage={deliItemUomError}
                                placeholder={translate("Select...")}
                                disabled={
                                  props.context.store.shopType === "BRANCH" ||
                                  deptId.deliItem != true
                                }
                                onChange={(event, newValue) => {
                                  setDeliitemuom(newValue);
                                }}
                              ></PSelect>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </tr>
                  )}
                  {props.productType != "R" && (
                    <tr>
                      <table width="100%">
                        <tbody>
                          <tr>
                            <td width="25%">{translate("Symbol")}</td>
                            <td style={{ paddingRight: "10px" }}>
                              <PText
                                style={{ marginLeft: "1%" }}
                                value={unitSymbol}
                                error={unitSymbolError}
                                disabled={
                                  props.context.store.shopType === "BRANCH" ||
                                  deptId.deliItem != true
                                }
                                onChange={(e) => setUnitsymbol(e.target.value)}
                              ></PText>
                            </td>
                            <td>{translate("Stock")}</td>
                            <td>
                              <PText
                                style={{ marginLeft: "20%", width: "76%" }}
                                value={currentStock}
                                disabled
                                error={currentStockError}
                                onChange={(e) =>
                                  setCurrentstock(e.target.value)
                                }
                              ></PText>
                            </td>
                            <td style={{ paddingRight: "10px" }}>
                              <Tooltip title={"Stock Details"}>
                                <IconButton
                                  style={{ marginRight: "15%" }}
                                  color="primary"
                                  onClick={(event) => {
                                    calulateStock();
                                    setSummaryViewOpen(true);
                                  }}
                                >
                                  <InfoOutlinedIcon />
                                </IconButton>
                              </Tooltip>
                              <Popover
                                open={summaryViewOpen}
                                onClose={handleClose}
                                anchorOrigin={{
                                  vertical: Number(200),
                                  horizontal: Number(1280),
                                }}
                              >
                                <Card style={{ marginTop: 5 }}>
                                  <CardContent
                                    style={{ backgroundColor: "#f5f4f2" }}
                                  >
                                    <Typography variant="body1">
                                      <b>
                                        {translate("Stock by Multiple Units")}
                                      </b>
                                    </Typography>
                                    <table width="100%">
                                      <tbody>
                                        {stockCalculation.map(
                                          (item) =>
                                            item && (
                                              <tr
                                                style={{
                                                  textAlign: "center",
                                                  text: "Bold",
                                                }}
                                              >
                                                <td> {item[0].name}</td>
                                                <td>:</td>
                                                <td
                                                  style={{
                                                    paddingLeft: "10px",
                                                  }}
                                                >
                                                  {item[0].value}
                                                </td>
                                              </tr>
                                            )
                                        )}
                                      </tbody>
                                    </table>
                                  </CardContent>
                                </Card>
                              </Popover>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </tr>
                  )}
                  <tr>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="37.5%">
                            <PCheck
                              onChange={(value) => {
                                setIncludediscinprice(value);
                                let tempPricingData = [...pricingData];
                                tempPricingData.map((item) => {
                                  item[8].info.incDisc = value;
                                });
                              }}
                              checked={includeDiscInPrice}
                              disabled={
                                props.context.store.shopType === "BRANCH"
                              }
                              label={translate("Discount in Price")}
                            ></PCheck>
                          </td>

                          {props.context.appType != "R_POS" && (
                            <td width="30%">
                              <PCheck
                                onChange={(value) => {
                                  setIsKitItem(value);
                                  setIsStockItem(false);
                                  if (!value) {
                                    setTabValue(0);
                                  }
                                }}
                                checked={isKitItem}
                                disabled={
                                  props.context.store.shopType === "BRANCH"
                                }
                                label={translate("Is Kit Item")}
                              ></PCheck>
                            </td>
                          )}

                          {props.context.appType === "R_POS" &&
                          props.productType == "R" ? (
                            <td width="35%">
                              <PCheck
                                onChange={(value) => {
                                  setIsKitItem(value);
                                  setIsStockItem(false);
                                  if (!value) {
                                    setTabValue(0);
                                  }
                                }}
                                checked={isKitItem}
                                disabled={
                                  props.context.store.shopType === "BRANCH"
                                }
                                label={translate("Is Combo Item")}
                              ></PCheck>
                            </td>
                          ) : (
                            <td width="35%">
                              <PCheck
                                onChange={(value) => {
                                  setIsForPos(value);
                                }}
                                checked={isForPos}
                                disabled={
                                  props.context.store.shopType === "BRANCH"
                                }
                                label={translate("Is for POS")}
                              ></PCheck>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </tr>

                  <tr>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="37.5%">
                            <PCheck
                              onChange={(value) => setIsdiscounted(value)}
                              checked={isDiscounted}
                              disabled={
                                props.context.store.shopType === "BRANCH"
                              }
                              label={"Enable promotion"}
                            ></PCheck>
                          </td>

                          <td width="75%">
                            <PCheck
                              onChange={(value) => {
                                setIncludetaxinprice(value);
                                let tempPricingData = [...pricingData];
                                tempPricingData.map((item) => {
                                  item[8].info.incTax = value;
                                });
                                setPricingData(tempPricingData);
                              }}
                              checked={includeTaxInPrice}
                              disabled={
                                props.context.store.shopType === "BRANCH"
                              }
                              label={translate("Tax in Price")}
                            ></PCheck>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </tr>

                  <tr>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="30%">
                            <PCheck
                              onChange={(value) => setFastitem(value)}
                              checked={fastItem}
                              disabled={
                                props.context.store.shopType === "BRANCH"
                              }
                              label={translate("Is Fast Item")}
                            ></PCheck>
                          </td>
                          <td width="50%">
                            <PCheck
                              onChange={(value) => setIsOpenQty(value)}
                              checked={isOpenQty}
                              disabled={
                                props.context.store.shopType === "BRANCH"
                              }
                              label={translate("Is Open Quantity")}
                            ></PCheck>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </tr>

                  <tr>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="30%">
                            {props.productType != "R" && (
                              <PCheck
                                onChange={(value) => setIsopenprice(value)}
                                checked={isOpenPrice}
                                disabled={
                                  props.context.store.shopType === "BRANCH"
                                }
                                label={translate("Is Open Price")}
                              ></PCheck>
                            )}
                          </td>
                          <td width="50%">
                            {props.productType != "R" && (
                              <PCheck
                                onChange={(value) => setIsStockItem(value)}
                                checked={isStockItem}
                                label={translate("Is Stock Item")}
                                disabled={
                                  isKitItem ||
                                  props.context.store.shopType === "BRANCH"
                                }
                              ></PCheck>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </tr>
                  {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
                </tbody>
              </table>{" "}
            </Grid>
            <Grid item xs={12}>
              <div
                style={{
                  marginTop: "10px",
                  marginLeft: "5px",
                  marginRight: "5px",
                }}
              >
                {showProductPricing && (
                  <ProductPricing
                    biRef={biRefPrice}
                    opType={mode}
                    origObject={props.origObject}
                    promotionOptions={props.promotionOptions}
                    unitTypeOptions={props.unitTypeOptions}
                    pricingLevels={props.pricingLevels}
                    pricingData={pricingData}
                    setPricingData={setPricingData}
                    incTax={includeTaxInPrice}
                    incDisc={includeDiscInPrice}
                    deptId={deptId}
                    setAlert={props.setAlert}
                    showMessage={props.showMessage}
                    showProgress={props.showProgress}
                    hideProgress={props.hideProgress}
                    setProgressMessage={props.setProgressMessage}
                    context={props.context}
                    taxId={taxId}
                    storeAdminSetting={props.storeAdminSetting}
                    productType={props.productType}
                  ></ProductPricing>
                )}
              </div>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={outerTabValue} index={1} style={{ padding: 0 }}>
          <Grid container style={{ height: "602px" }}>
            <Grid item xs={12}>
              <ProductStockBatchView
                //openWindow={openWindow}
                //tableMeta={tableMeta}
                showMessage={props.showMessage}
                origObject={props.origObject}
                context={props.context}
              ></ProductStockBatchView>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={outerTabValue} index={2} style={{ padding: 0 }}>
          <Grid container style={{ height: "602px" }}>
            <Grid item xs={12}>
              <ProductHistory
                context={props.context}
                setAlert={props.setAlert}
                showMessage={props.showMessage}
                productBean={props.origObject}
              ></ProductHistory>
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={outerTabValue} index={3}>
          <Grid container spacing={1} style={{ height: "610px" }}>
            <Grid item xs={12}>
              <ProductImages
                filesList={filesList}
                setFilesList={setFilesList}
                showMessage={props.showMessage}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel value={outerTabValue} index={4}>
          <Card style={{ width: "100%" }}>
            <CardContent style={{ backgroundColor: "#fafafa" }}>
              <Grid container style={{ height: "563px" }}>
                <Grid item xs={12}>
                  <table width="50%">
                    {productInfoFields.map((item) => (
                      <tr key={item.key}>
                        <td style={{ marginBottom: "10px" }}>{item.label}</td>
                        <td style={{ marginBottom: "10px" }}>
                          <PText
                            value={item.value}
                            error={item.error}
                            onChange={(e) => {
                              let custom = [...productInfoFields];
                              custom[item.index].value = e.target.value;
                              setProductInfoFields(custom);
                            }}
                          ></PText>
                        </td>
                      </tr>
                    ))}
                  </table>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>
        <TabPanel value={outerTabValue} index={5}>
          <Grid container spacing={1} style={{ height: "600px" }}>
            <Grid item xs={12}>
              <KitItems
                kitItemsList={kitItemsList}
                setKitItemsList={setKitItemsList}
                isExpandOnSale={isExpandOnSale}
                setIsExpandOnSale={setIsExpandOnSale}
                context={props.context}
                showMessage={props.showMessage}
              />
            </Grid>
          </Grid>
        </TabPanel>
      </div>
    </ThemeProvider>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
      if (!code || code !== "AUTO") return true;
      if (deptId || deptId != "") return true;
      if (subDeptId || subDeptId != "") return true;
      if (catId || catId != "") return true;
      if (subCatId || subCatId != "") return true;
      if (vendorId || vendorId != "") return true;
      if (taxId || taxId != "") return true;
      if (shortName || shortName != "") return true;
      if (localName || localName != "") return true;
      if (deliItemUom || deliItemUom != "") return true;
      if (shortName || shortName != "") return true;
      if (unitSymbol || unitSymbol != "") return true;
      //if (currentStock || currentStock != "") return true;
      if (isOpenPrice || isOpenPrice != "") return true;
      if (isOpenQty || isOpenQty != "") return true;
      if (isDiscounted || isDiscounted != "") return true;
      if (includeTaxInPrice || includeTaxInPrice != "") return true;
      if (includeDiscInPrice || includeDiscInPrice != "") return true;
      if (fastItem || fastItem != "") return true;
      /*CODEGEN_DATA_CHANGE_DETECTION_CREATE ######## DO_NOT_REMOVE ###########*/
    }
    if (mode === "edit") {
      console.log(
        (deliItemUom ? deliItemUom.id : null) +
          "===" +
          props.origObject.deliItemUom
      );
      if (name !== props.origObject.name) return true;
      if (code !== props.origObject.code) return true;
      if ((deptId ? deptId.id : null) !== props.origObject.deptId) return true;
      if ((subDeptId ? subDeptId.id : null) !== props.origObject.subDeptId)
        return true;
      if ((catId ? catId.id : null) !== props.origObject.catId) return true;
      if ((subCatId ? subCatId.id : null) !== props.origObject.subCatId)
        return true;
      if ((vendorId ? vendorId.id : null) !== props.origObject.vendorId)
        return true;
      if ((taxId ? taxId.id : null) !== props.origObject.taxId) return true;
      if (localName !== props.origObject.localName) return true;
      if (shortName !== props.origObject.shortName) return true;
      //TODO HARI
      if (
        (deliItemUom ? deliItemUom.value : null) !==
        props.origObject.deliItemUom
          ? props.origObject.deliItemUom
          : null
      )
        return true;
      if (unitSymbol !== props.origObject.unitSymbol) return true;
      // if (currentStock !== currentStock) return true;
      if (isOpenPrice !== isOpenPrice) return true;
      if (isOpenQty !== isOpenQty) return true;
      if (isDiscounted !== isDiscounted) return true;
      if (includeTaxInPrice !== includeTaxInPrice) return true;
      if (includeDiscInPrice !== includeDiscInPrice) return true;
      if (fastItem !== fastItem) return true;
      //TODO HARI check Pricing Changes
      /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    }
    return false;
  }
  function onBarcodeScanned(txtCodeKeyPressed) {
    console.log(txtCodeKeyPressed);
  }
  function rejectdBarcode(rejectdBarcode) {
    console.log(txtCodeKeyPressed);
  }
  return (
    <div>
      <PDialog
        content={content}
        title={windowTitle}
        open={true}
        maxWidth={"xl"}
        fullWidth={true}
        onCloseWindow={onCloseWindow}
        onSave={props.readOnly ? null : onSave}
        hideSave={
          props.context.privileges.delete_product &&
          !props.context.privileges.edit_product
            ? true
            : false
        }
        onDelete={props.context.privileges.delete_product ? onDelete : false}
        // mode={
        //   props.readOnly || !props.context.privileges.edit_product
        //     ? "view"
        //     : mode
        // }
        mode={props.readOnly ? "view" : mode}
        isDataChanged={isDataChanged}
        showNew={
          props.readOnly || !props.context.privileges.edit_product
            ? false
            : mode == "edit"
            ? true
            : false
        }
        onNewClicked={onNewClicked}
        borderLess={true}
        withActions={!borderLess}
      ></PDialog>

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      <VendorCrud
        biRef={biRef}
        showMessage={props.showMessage}
        selectVendor={selectVendor}
        context={props.context}
      ></VendorCrud>
      <CategoryCrud
        biRef={biRef}
        showMessage={props.showMessage}
        selectCategory={selectCategory}
        context={props.context}
      ></CategoryCrud>
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        >
          <BarcodeReader
            onError={rejectdBarcode}
            onScan={onBarcodeScanned}
            preventDefault={true}
          ></BarcodeReader>
        </PDialog>
      )}
    </div>
  );
}
